<template style="height: 100%;">
  <div class="RPStatistics">
    <div class="box">
      <div style="width:98%;margin:auto;padding-top:20px; min-width: 1800px;" class="aaaaa">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="boxtop">
              上海健康医学院信息统计
            </div>
          </el-col>
        </el-row>
      </div>

      <div style="width:98%;margin:auto;padding-top:20px; min-width: 1800px;">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="boxtitle">
              学院基本信息
            </div>
          </el-col>
        </el-row>
      </div>

      <div style="width:98%;margin:auto;padding-top:20px; min-width: 1800px;">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="grid-content bg-purple" id="Faculty"></div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple" id="PoorStu"></div>
          </el-col>
          <el-col :span="6" style="min-width: 450px;">
            <div class="grid-content bg-purple" id="Degree"></div>
          </el-col>
        </el-row>
      </div>
      <div style="width:98%;margin:auto;padding-top:20px; min-width: 1800px;">
        <el-row :gutter="20">
          <el-col :span="18">
            <div class="grid-content bg-purple" id="Specialty">
              ccc
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple" id="EntryDate"></div>
          </el-col>
        </el-row>
      </div>
      <div style="width:98%;margin:auto;padding-top:20px; min-width: 1800px;">
        <el-row :gutter="20">
          <el-col :span="18">
            <div class="grid-content bg-purple" id="Dormitory"></div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple" id="District"></div>
          </el-col>
        </el-row>
      </div>
      <div style="width:98%;margin:auto;padding-top:20px; min-width: 1800px;">
        <el-row :gutter="20">
          <el-col :span="18">
            <div class="grid-content bg-purple" id="FloorNo"></div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple" id="Nation"></div>
          </el-col>
        </el-row>
      </div>
      <div style="width:98%;margin:auto;padding-top:20px; min-width: 1800px;">
        <el-row :gutter="20">
          <el-col :span="18">
            <div class="grid-content bg-purple" id="PlaceOrigin"></div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple" id="StudentList"></div>
          </el-col>
        </el-row>
      </div>

      <div style="width:98%;margin:auto;padding-top:20px; min-width: 1800px;">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="boxtitle">
              心理健康统计
            </div>
          </el-col>
        </el-row>
      </div>

      <div style="width:98%;margin:auto;padding-top:20px; min-width: 1800px;">
        <el-row :gutter="20">
          <el-col :span="18">
            <div class="grid-content bg-purple" id="InduceProblems"></div>
          </el-col>
          <el-col :span="6" style="min-width: 450px;">
            <div class="grid-content bg-purple" id="ConcernType"></div>
          </el-col>
        </el-row>
      </div>
      <div style="width:98%;margin:auto;padding-top:20px;  min-width: 1800px;">
        <el-row :gutter="20">
          <el-col :span="8" style="min-width: 510px;">
            <div class="grid-content bg-purple" id="PsychologicalPro"></div>
          </el-col>
          <el-col :span="8" style="min-width: 510px;">
            <div class="grid-content bg-purple" id="CrisisType"></div>
          </el-col>
          <el-col :span="8" style="min-width: 510px;">
            <div class="grid-content bg-purple" id="PsychologicalHis"></div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      xData: [],
      yData: [],
    };
  },
  methods: {
    Loading(val) {
      this.$Http_Post('ReportCriData/GetAllStatisticsInfo')
        .then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            //院系
            var ResData = res.Data.Faculty;
            for (var p in ResData) {
              this.xData.push(ResData[p].name);
              this.yData.push(ResData[p].value);
            }
            let myChart = this.$echarts.init(
              document.getElementById('Faculty'),
              'shine'
            );
            myChart.setOption({
              title: {
                text: '院系',
                x: 'center',
                show: true,
                textStyle: {
                  //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                  fontSize: 20,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  color: 'rgba(46, 168, 244, 1)',
                },
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow',
                },
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true,
              },
              xAxis: [
                {
                  type: 'category',
                  data: this.xData,
                  axisTick: {
                    alignWithLabel: true,
                  },
                },
              ],
              yAxis: [
                {
                  type: 'value',
                },
              ],
              series: [
                {
                  name: '人数',
                  type: 'bar',
                  barWidth: '60%',
                  barMaxWidth: '50',
                  itemStyle: {
                    normal: {
                      //这里是颜色
                      color: function (params) {
                        //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                        var colorList = [
                          '#00A3E0',
                          '#FFA100',
                          '#ffc0cb',
                          '#CCCCCC',
                          '#BBFFAA',
                          '#749f83',
                          '#ca8622',
                        ];
                        return colorList[params.dataIndex];
                      },
                    },
                  },
                  data: this.yData,
                },
              ],
            });
            //自动适应大小
            window.addEventListener('resize', function () {
              myChart.resize();
            });
            this.xData = [];
            this.yData = [];

            //PoorStu  贫困生
            var PoorStu = res.Data.PoorStu;
            let myChart1 = this.$echarts.init(
              document.getElementById('PoorStu'),
              'shine'
            );
            myChart1.setOption({
              title: {
                text: '是否为贫困生',
                x: 'center',
                show: true,
                textStyle: {
                  //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                  fontSize: 20,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  color: 'rgba(46, 168, 244, 1)',
                },
              },
              tooltip: {
                trigger: 'item',
              },
              // legend: {
              //   orient: 'vertical',
              //   y: '9%', //可设定图例在上、下、居中
              //   left: '1%',
              //   textStyle: {
              //     //图例文字的样式
              //     color: '#6495ED',
              //     fontSize: 14,
              //   },
              // },
              series: [
                {
                  name: '数据源',
                  type: 'pie',
                  radius: '80%',
                  left: 'center', //离容器左侧的距离
                  top: 'top', //距离容器上测的距离
                  center: ['50%', '60%'],
                  data: PoorStu,
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                  },
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                    normal: {
                      color: function (params) {
                        //自定义颜色
                        var colorList = [
                          '#C05852',
                          '#C9A660',
                          '#3283C1',
                          '#34B28E',
                          '#FF0000',
                          '#FE8463',
                        ];
                        return colorList[params.dataIndex];
                      },
                    },
                  },
                  label: {
                    normal: {
                      // formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                      formatter: '{a|{b}}\n{hr|}\n{per|{d}%}',
                      rich: {
                        a: {
                          color: 'rgb(81,183,246)',
                          fontSize: 11,
                          lineHeight: 20,
                          align: 'center',
                        },
                        hr: {
                          width: '100%',
                          height: 0,
                          alien: 'center',
                        },
                        per: {
                          color: '#000000',
                          align: 'center',
                          fontSize: 15,
                        },
                      },
                    },
                  },
                },
              ],
            });
            //自动适应大小
            window.addEventListener('resize', function () {
              myChart1.resize();
            });
            this.xData = [];
            this.yData = [];

            //学历
            var Degree = res.Data.Degree;
            let myChart2 = this.$echarts.init(
              document.getElementById('Degree'),
              'shine'
            );
            myChart2.setOption({
              title: {
                text: '学历',
                x: 'center',
                show: true,
                textStyle: {
                  //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                  fontSize: 20,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  color: 'rgba(46, 168, 244, 1)',
                },
              },
              tooltip: {
                trigger: 'item',
              },
              // legend: {
              //   orient: 'vertical',
              //   y: '9%', //可设定图例在上、下、居中
              //   left: '1%',
              //   textStyle: {
              //     //图例文字的样式
              //     color: '#6495ED',
              //     fontSize: 14,
              //   },
              // },
              series: [
                {
                  avoidLabelOverlap: true,
                  name: '数据源',
                  minAngle: 5,
                  type: 'pie',
                  radius: '50%',
                  left: '10%', //离容器左侧的距离
                  top: 'top', //距离容器上测的距离
                  center: ['50%', '60%'],
                  data: Degree,
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                  },
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                    normal: {
                      color: function (params) {
                        //自定义颜色
                        var colorList = [
                          '#C05852',
                          '#C9A660',
                          '#3283C1',
                          '#34B28E',
                          '#FF0000',
                          '#FE8463',
                        ];
                        return colorList[params.dataIndex];
                      },
                    },
                  },
                  label: {
                    normal: {
                      // formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                      formatter: '{a|{b}}\n{hr|}\n{per|{d}%}',
                      rich: {
                        a: {
                          color: 'rgb(81,183,246)',
                          fontSize: 11,
                          lineHeight: 20,
                          align: 'center',
                        },
                        hr: {
                          width: '100%',
                          height: 0,
                          alien: 'center',
                        },
                        per: {
                          color: '#000000',
                          align: 'center',
                          fontSize: 15,
                        },
                      },
                    },
                  },
                },
              ],
            });
            //自动适应大小
            window.addEventListener('resize', function () {
              myChart2.resize();
            });
            this.xData = [];
            this.yData = [];

            //专业 Specialty
            var Specialty = res.Data.Specialty;
            for (var p in Specialty) {
              this.xData.push(Specialty[p].name);
              this.yData.push(Specialty[p].value);
            }

            let myChart3 = this.$echarts.init(
              document.getElementById('Specialty'),
              'shine'
            );
            myChart3.setOption({
              title: {
                text: '专业',
                x: 'center',
                show: true,
                textStyle: {
                  //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                  fontSize: 20,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  color: 'rgba(46, 168, 244, 1)',
                },
              },
              tooltip: {
                trigger: 'item',
              },
              legend: {
                orient: 'vertical',
                y: '9%', //可设定图例在上、下、居中
                left: '1%',
                textStyle: {
                  //图例文字的样式
                  color: '#6495ED',
                  fontSize: 14,
                },
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: this.xData,
              },
              yAxis: {
                type: 'value',
              },
              series: [
                {
                  data: this.yData,
                  type: 'line',
                  areaStyle: {},
                  barMaxWidth: '50',
                  symbolSize: 6, //设置折线上圆点大小
                  itemStyle: {
                    normal: {
                      label: {
                        show: true, // 在折线拐点上显示数据
                      },
                      lineStyle: {
                        width: 0, // 设置虚线宽度
                        type: 'dotted', // 虚线'dotted' 实线'solid'
                      },
                    },
                  },
                },
              ],
            });
            //自动适应大小
            window.addEventListener('resize', function () {
              myChart3.resize();
            });
            this.xData = [];
            this.yData = [];

            //年级 EntryDate
            var EntryDate = res.Data.EntryDate;
            let myChart4 = this.$echarts.init(
              document.getElementById('EntryDate'),
              'shine'
            );
            myChart4.setOption({
              title: {
                text: '年级',
                x: 'center',
                show: true,
                textStyle: {
                  //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                  fontSize: 20,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  color: 'rgba(46, 168, 244, 1)',
                },
              },
              tooltip: {
                trigger: 'item',
              },
              // legend: {
              //   orient: 'vertical',
              //   y: '9%', //可设定图例在上、下、居中
              //   left: '1%',
              //   textStyle: {
              //     //图例文字的样式
              //     color: '#6495ED',
              //     fontSize: 14,
              //   },
              // },
              series: [
                {
                  name: '数据源',
                  type: 'pie',
                  radius: '80%',
                  left: 'center', //离容器左侧的距离
                  top: 'top', //距离容器上测的距离
                  center: ['50%', '60%'],
                  data: EntryDate,
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                  },
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                    normal: {
                      color: function (params) {
                        //自定义颜色
                        var colorList = [
                          '#C05852',
                          '#C9A660',
                          '#3283C1',
                          '#34B28E',
                          '#FF0000',
                          '#FE8463',
                        ];
                        return colorList[params.dataIndex];
                      },
                    },
                  },
                  label: {
                    normal: {
                      // formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                      formatter: '{a|{b}}\n{hr|}\n{per|{d}%}',

                      rich: {
                        a: {
                          color: 'rgb(81,183,246)',
                          fontSize: 14,
                          lineHeight: 20,
                          align: 'center',
                        },
                        hr: {
                          width: '100%',
                          height: 0,
                          alien: 'center',
                        },
                        per: {
                          color: '#000000',
                          align: 'center',
                          fontSize: 14,
                        },
                      },
                    },
                  },
                },
              ],
            });
            //自动适应大小
            window.addEventListener('resize', function () {
              myChart4.resize();
            });
            this.xData = [];
            this.yData = [];

            //宿舍楼 Dormitory
            var ResData = res.Data.Dormitory;
            for (var p in ResData) {
              this.xData.push(ResData[p].name);
              this.yData.push(ResData[p].value);
            }
            let myChart5 = this.$echarts.init(
              document.getElementById('Dormitory'),
              'shine'
            );
            myChart5.setOption({
              title: {
                text: '宿舍楼',
                x: 'center',
                show: true,
                textStyle: {
                  //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                  fontSize: 20,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  color: 'rgba(46, 168, 244, 1)',
                },
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow',
                },
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true,
              },
              xAxis: [
                {
                  type: 'category',
                  data: this.xData,
                  axisTick: {
                    alignWithLabel: true,
                  },
                },
              ],
              yAxis: [
                {
                  type: 'value',
                },
              ],
              series: [
                {
                  name: '人数',
                  type: 'bar',
                  barWidth: '60%',
                  barMaxWidth: '50',
                  itemStyle: {
                    normal: {
                      //这里是颜色
                      color: function (params) {
                        //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                        var colorList = [
                          '#00A3E0',
                          '#FFA100',
                          '#ffc0cb',
                          '#CCCCCC',
                          '#BBFFAA',
                          '#749f83',
                          '#ca8622',
                        ];
                        return colorList[params.dataIndex];
                      },
                    },
                  },
                  data: this.yData,
                },
              ],
            });
            //自动适应大小
            window.addEventListener('resize', function () {
              myChart5.resize();
            });
            this.xData = [];
            this.yData = [];

            //苑区 District
            var PoorStu = res.Data.District;
            let myChart6 = this.$echarts.init(
              document.getElementById('District'),
              'shine'
            );
            myChart6.setOption({
              title: {
                text: '苑区',
                x: 'center',
                show: true,
                textStyle: {
                  //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                  fontSize: 20,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  color: 'rgba(46, 168, 244, 1)',
                },
              },
              tooltip: {
                trigger: 'item',
              },
              // legend: {
              //   orient: 'vertical',
              //   y: '9%', //可设定图例在上、下、居中
              //   left: '1%',
              //   textStyle: {
              //     //图例文字的样式
              //     color: '#6495ED',
              //     fontSize: 14,
              //   },
              // },
              series: [
                {
                  name: '数据源',
                  type: 'pie',
                  radius: '80%',
                  left: 'center', //离容器左侧的距离
                  top: 'top', //距离容器上测的距离
                  center: ['50%', '60%'],
                  data: PoorStu,
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                  },
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                    normal: {
                      color: function (params) {
                        //自定义颜色
                        var colorList = [
                          '#C05852',
                          '#C9A660',
                          '#3283C1',
                          '#34B28E',
                          '#FF0000',
                          '#FE8463',
                        ];
                        return colorList[params.dataIndex];
                      },
                    },
                  },
                  label: {
                    normal: {
                      // formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                      formatter: '{a|{b}}\n{hr|}\n{per|{d}%}',
                      rich: {
                        a: {
                          color: 'rgb(81,183,246)',
                          fontSize: 11,
                          lineHeight: 20,
                          align: 'center',
                        },
                        hr: {
                          width: '100%',
                          height: 0,
                          alien: 'center',
                        },
                        per: {
                          color: '#000000',
                          align: 'center',
                          fontSize: 15,
                        },
                      },
                    },
                  },
                },
              ],
            });
            //自动适应大小
            window.addEventListener('resize', function () {
              myChart6.resize();
            });
            this.xData = [];
            this.yData = [];

            //楼层号 FloorNo
            var ResData = res.Data.FloorNo;
            for (var p in ResData) {
              this.xData.push(ResData[p].name);
              this.yData.push(ResData[p].value);
            }
            let myChart7 = this.$echarts.init(
              document.getElementById('FloorNo'),
              'shine'
            );
            myChart7.setOption({
              title: {
                text: '楼层号',
                x: 'center',
                show: true,
                textStyle: {
                  //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                  fontSize: 20,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  color: 'rgba(46, 168, 244, 1)',
                },
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow',
                },
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true,
              },
              xAxis: [
                {
                  type: 'category',
                  data: this.xData,
                  axisTick: {
                    alignWithLabel: true,
                  },
                },
              ],
              yAxis: [
                {
                  type: 'value',
                },
              ],
              series: [
                {
                  name: '人数',
                  type: 'bar',
                  barMaxWidth: '50',
                  itemStyle: {
                    normal: {
                      //这里是颜色
                      color: function (params) {
                        //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                        var colorList = [
                          '#00A3E0',
                          '#FFA100',
                          '#ffc0cb',
                          '#CCCCCC',
                          '#BBFFAA',
                          '#749f83',
                          '#ca8622',
                        ];
                        return colorList[params.dataIndex];
                      },
                    },
                  },
                  data: this.yData,
                },
              ],
            });
            //自动适应大小
            window.addEventListener('resize', function () {
              myChart7.resize();
            });
            this.xData = [];
            this.yData = [];

            //民族 Nation
            var Nation = res.Data.Nation;
            let myChart8 = this.$echarts.init(
              document.getElementById('Nation'),
              'shine'
            );
            myChart8.setOption({
              title: {
                text: '民族',
                x: 'center',
                show: true,
                textStyle: {
                  //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                  fontSize: 20,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  color: 'rgba(46, 168, 244, 1)',
                },
              },
              tooltip: {
                trigger: 'item',
              },
              // legend: {
              //   orient: 'vertical',
              //   y: '9%', //可设定图例在上、下、居中
              //   left: '1%',
              //   textStyle: {
              //     //图例文字的样式
              //     color: '#6495ED',
              //     fontSize: 14,
              //   },
              // },
              series: [
                {
                  name: '数据源',
                  type: 'pie',
                  radius: '80%',
                  left: 'center', //离容器左侧的距离
                  top: 'top', //距离容器上测的距离
                  center: ['50%', '60%'],
                  data: Nation,
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                  },
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                    normal: {
                      color: function (params) {
                        //自定义颜色
                        var colorList = [
                          '#C05852',
                          '#C9A660',
                          '#3283C1',
                          '#34B28E',
                          '#FF0000',
                          '#FE8463',
                        ];
                        return colorList[params.dataIndex];
                      },
                    },
                  },
                  label: {
                    normal: {
                      // formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                      formatter: '{a|{b}}\n{hr|}\n{per|{d}%}',
                      rich: {
                        a: {
                          color: 'rgb(81,183,246)',
                          fontSize: 11,
                          lineHeight: 20,
                          align: 'center',
                        },
                        hr: {
                          width: '100%',
                          height: 0,
                          alien: 'center',
                        },
                        per: {
                          color: '#000000',
                          align: 'center',
                          fontSize: 15,
                        },
                      },
                    },
                  },
                },
              ],
            });
            //自动适应大小
            window.addEventListener('resize', function () {
              myChart8.resize();
            });
            this.xData = [];
            this.yData = [];

            //生源地 PlaceOrigin
            var ResData = res.Data.PlaceOrigin;
            for (var p in ResData) {
              this.xData.push(ResData[p].name);
              this.yData.push(ResData[p].value);
            }
            let myChart9 = this.$echarts.init(
              document.getElementById('PlaceOrigin'),
              'shine'
            );
            myChart9.setOption({
              title: {
                text: '生源地',
                x: 'center',
                show: true,
                textStyle: {
                  //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                  fontSize: 20,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  color: 'rgba(46, 168, 244, 1)',
                },
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow',
                },
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true,
              },
              xAxis: [
                {
                  type: 'category',
                  data: this.xData,
                  axisTick: {
                    alignWithLabel: true,
                  },
                  axisLabel: {
                    interval: 0,
                    rotate: 45
                  }
                },
              ],
              yAxis: [
                {
                  type: 'value',
                },
              ],
              series: [
                {
                  name: '人数',
                  type: 'bar',
                  barMaxWidth: '50',
                  itemStyle: {
                    normal: {
                      //这里是颜色
                      color: function (params) {
                        //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                        var colorList = [
                          '#00A3E0',
                          '#FFA100',
                          '#ffc0cb',
                          '#CCCCCC',
                          '#BBFFAA',
                          '#749f83',
                          '#ca8622',
                        ];
                        return colorList[params.dataIndex];
                      },
                    },
                  },
                  data: this.yData,
                },
              ],
            });
            //自动适应大小
            window.addEventListener('resize', function () {
              myChart9.resize();
            });
            this.xData = [];
            this.yData = [];

            //学籍异动 StudentList
            var studentData = res.Data.StudentList;
            let myChart15 = this.$echarts.init(
              document.getElementById('StudentList'),
              'shine'
            );
            myChart15.setOption({
              title: {
                text: '学籍异动',
                x: 'center',
                show: true,
                textStyle: {
                  //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                  fontSize: 20,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  color: 'rgba(46, 168, 244, 1)',
                },
              },
              tooltip: {
                trigger: 'item',
              },
              // legend: {
              //   orient: 'vertical',
              //   y: '9%', //可设定图例在上、下、居中
              //   left: '1%',
              //   textStyle: {
              //     //图例文字的样式
              //     color: '#6495ED',
              //     fontSize: 14,
              //   },
              // },
              series: [
                {
                  name: '数据源',
                  type: 'pie',
                  radius: '50%',
                  left: '10%', //离容器左侧的距离
                  top: 'top', //距离容器上测的距离
                  center: ['50%', '50%'],
                  data: studentData,
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                  },
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                    normal: {
                      color: function (params) {
                        //自定义颜色
                        var colorList = [
                          '#C05852',
                          '#C9A660',
                          '#3283C1',
                          '#34B28E',
                          '#FF0000',
                          '#FE8463',
                        ];
                        return colorList[params.dataIndex];
                      },
                    },
                  },
                  label: {
                    normal: {
                      // formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                      formatter: '{a|{b}}\n{hr|}\n{per|{d}%}',
                      rich: {
                        a: {
                          color: 'rgb(81,183,246)',
                          fontSize: 11,
                          lineHeight: 20,
                          align: 'center',
                        },
                        hr: {
                          width: '100%',
                          height: 0,
                          alien: 'center',
                        },
                        per: {
                          color: '#000000',
                          align: 'center',
                          fontSize: 15,
                        },
                      },
                    },
                  },
                },
              ],
            });
            //自动适应大小
            window.addEventListener('resize', function () {
              myChart15.resize();
            });
            this.xData = [];
            this.yData = [];

            //诱发问题 InduceProblems
            var ResData = res.Data.InduceProblems;
            for (var p in ResData) {
              this.xData.push(ResData[p].name);
              this.yData.push(ResData[p].value);
            }
            let myChart10 = this.$echarts.init(
              document.getElementById('InduceProblems'),
              'shine'
            );
            myChart10.setOption({
              title: {
                text: '诱发问题',
                x: 'center',
                show: true,
                textStyle: {
                  //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                  fontSize: 20,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  color: 'rgba(46, 168, 244, 1)',
                },
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow',
                },
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true,
              },
              xAxis: [
                {
                  type: 'category',
                  data: this.xData,
                  axisTick: {
                    alignWithLabel: true,
                  },
                  axisLabel: {
                    interval: 0,
                    rotate: 45
                  }
                },
              ],
              yAxis: [
                {
                  type: 'value',
                },
              ],
              series: [
                {
                  name: '人数',
                  type: 'bar',
                  barMaxWidth: '50',
                  itemStyle: {
                    normal: {
                      //这里是颜色
                      color: function (params) {
                        //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                        var colorList = [
                          '#00A3E0',
                          '#FFA100',
                          '#ffc0cb',
                          '#CCCCCC',
                          '#BBFFAA',
                          '#749f83',
                          '#ca8622',
                        ];
                        return colorList[params.dataIndex];
                      },
                    },
                  },
                  data: this.yData,
                },
              ],
            });
            //自动适应大小
            window.addEventListener('resize', function () {
              myChart10.resize();
            });
            this.xData = [];
            this.yData = [];

            //关注类型 ConcernType
            var Nation = res.Data.ConcernType;
            let myChart11 = this.$echarts.init(
              document.getElementById('ConcernType'),
              'shine'
            );
            myChart11.setOption({
              title: {
                text: '关注类型',
                x: 'center',
                show: true,
                textStyle: {
                  //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                  fontSize: 20,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  color: 'rgba(46, 168, 244, 1)',
                },
              },
              tooltip: {
                trigger: 'item',
              },
              // legend: {
              //   orient: 'vertical',
              //   y: '9%', //可设定图例在上、下、居中
              //   left: '1%',
              //   textStyle: {
              //     //图例文字的样式
              //     color: '#6495ED',
              //     fontSize: 14,
              //   },
              // },
              series: [
                {
                  avoidLabelOverlap: true,
                  name: '数据源',
                  type: 'pie',
                  radius: '50%',
                  left: '10%', //离容器左侧的距离
                  top: 'top', //距离容器上测的距离
                  center: ['50%', '60%'],
                  data: Nation,
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                  },
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                    normal: {
                      color: function (params) {
                        //自定义颜色
                        var colorList = [
                          '#C05852',
                          '#C9A660',
                          '#3283C1',
                          '#34B28E',
                          '#FF0000',
                          '#FE8463',
                        ];
                        return colorList[params.dataIndex];
                      },
                    },
                  },
                  label: {
                    normal: {
                      // formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                      formatter: '{a|{b}}\n{hr|}\n{per|{d}%}',
                      rich: {
                        a: {
                          color: 'rgb(81,183,246)',
                          fontSize: 11,
                          lineHeight: 20,
                          align: 'center',
                        },
                        hr: {
                          width: '100%',
                          height: 0,
                          alien: 'center',
                        },
                        per: {
                          color: '#000000',
                          align: 'center',
                          fontSize: 15,
                        },
                      },
                    },
                  },
                },
              ],
            });
            //自动适应大小
            window.addEventListener('resize', function () {
              myChart11.resize();
            });
            this.xData = [];
            this.yData = [];

            //心理（精神）问题 PsychologicalPro
            var Nation = res.Data.PsychologicalPro;
            let myChart12 = this.$echarts.init(
              document.getElementById('PsychologicalPro'),
              'shine'
            );
            myChart12.setOption({
              title: {
                text: '心理（精神）问题',
                x: 'center',
                show: true,
                textStyle: {
                  //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                  fontSize: 20,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  color: 'rgba(46, 168, 244, 1)',
                },
              },
              tooltip: {
                trigger: 'item',
              },
              legend: {
                orient: 'vertical',
                y: '9%', //可设定图例在上、下、居中
                left: '1%',
                textStyle: {
                  //图例文字的样式
                  color: '#6495ED',
                  fontSize: 14,
                },
              },
              series: [
                {
                  avoidLabelOverlap: true,

                  name: '数据源',
                  type: 'pie',
                  radius: '50%',
                  left: '30%', //离容器左侧的距离 //离容器左侧的距离
                  top: 'top', //距离容器上测的距离
                  center: ['50%', '60%'],
                  data: Nation,
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                  },
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                    normal: {
                      color: function (params) {
                        //自定义颜色
                        var colorList = [
                          '#C05852',
                          '#C9A660',
                          '#3283C1',
                          '#34B28E',
                          '#FF0000',
                          '#FE8463',
                          '#AADD55',
                          '#EE6677',
                        ];
                        return colorList[params.dataIndex];
                      },
                    },
                  },
                  label: {
                    normal: {
                      // formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                      formatter: '{a|{b}}\n{hr|}\n{per|{d}%}',
                      rich: {
                        a: {
                          color: 'rgb(81,183,246)',
                          fontSize: 11,
                          lineHeight: 20,
                          align: 'center',
                        },
                        hr: {
                          width: '100%',
                          height: 0,
                          alien: 'center',
                        },
                        per: {
                          color: '#000000',
                          align: 'center',
                          fontSize: 15,
                        },
                      },
                    },
                  },
                },
              ],
            });
            //自动适应大小
            window.addEventListener('resize', function () {
              myChart12.resize();
            });

            this.xData = [];
            this.yData = [];
            //危机类型 CrisisType
            var CrisisType = res.Data.CrisisType;
            let myChart13 = this.$echarts.init(
              document.getElementById('CrisisType'),
              'shine'
            );
            myChart13.setOption({
              title: {
                text: '危机类型',
                x: 'center',
                show: true,
                textStyle: {
                  //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                  fontSize: 20,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  color: 'rgba(46, 168, 244, 1)',
                },
              },
              tooltip: {
                trigger: 'item',
              },
              legend: {
                orient: 'vertical',
                y: '9%', //可设定图例在上、下、居中
                left: '1%',
                textStyle: {
                  //图例文字的样式
                  color: '#6495ED',
                  fontSize: 14,
                },
              },
              series: [
                {
                  name: '数据源',
                  type: 'pie',
                  radius: '50%',
                  left: '30%', //离容器左侧的距离
                  top: 'top', //距离容器上测的距离
                  center: ['50%', '60%'],
                  data: CrisisType,
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                  },
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                    normal: {
                      color: function (params) {
                        //自定义颜色
                        var colorList = [
                          '#C05852',
                          '#C9A660',
                          '#3283C1',
                          '#34B28E',
                          '#FF0000',
                          '#FE8463',
                          '#AADD55',
                          '#EE6677',
                        ];
                        return colorList[params.dataIndex];
                      },
                    },
                  },
                  label: {
                    normal: {
                      // formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                      formatter: '{a|{b}}\n{hr|}\n{per|{d}%}',
                      rich: {
                        a: {
                          color: 'rgb(81,183,246)',
                          fontSize: 11,
                          lineHeight: 20,
                          align: 'center',
                        },
                        hr: {
                          width: '100%',
                          height: 0,
                          alien: 'center',
                        },
                        per: {
                          color: '#000000',
                          align: 'center',
                          fontSize: 15,
                        },
                      },
                    },
                  },
                },
              ],
            });
            //自动适应大小
            window.addEventListener('resize', function () {
              myChart13.resize();
            });
            this.xData = [];
            this.yData = [];

            //心理（精神）问题史 PsychologicalHis
            var psychologicalHis = res.Data.PsychologicalHis;
            let myChart14 = this.$echarts.init(
              document.getElementById('PsychologicalHis'),
              'shine'
            );
            myChart14.setOption({
              title: {
                text: '心理（精神）问题史',
                x: 'center',
                show: true,
                textStyle: {
                  //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
                  fontSize: 20,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  color: 'rgba(46, 168, 244, 1)',
                },
              },
              tooltip: {
                trigger: 'item',
              },
              legend: {
                orient: 'vertical',
                y: '9%', //可设定图例在上、下、居中
                left: '1%',
                textStyle: {
                  //图例文字的样式
                  color: '#6495ED',
                  fontSize: 14,
                },
              },
              series: [
                {
                  avoidLabelOverlap: true,
                  name: '数据源',
                  type: 'pie',
                  radius: '50%',
                  left: '30%', //离容器左侧的距离 //离容器左侧的距离
                  top: 'top', //距离容器上测的距离
                  center: ['50%', '60%'],
                  data: psychologicalHis,
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                  },
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                    normal: {
                      color: function (params) {
                        //自定义颜色
                        var colorList = [
                          '#C05852',
                          '#C9A660',
                          '#3283C1',
                          '#34B28E',
                          '#FF0000',
                          '#FE8463',
                          '#AADD55',
                          '#EE6677',
                        ];
                        return colorList[params.dataIndex];
                      },
                    },
                  },
                  label: {
                    normal: {
                      // formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                      formatter: '{a|{b}}\n{hr|}\n{per|{d}%}',
                      rich: {
                        a: {
                          color: 'rgb(81,183,246)',
                          fontSize: 11,
                          lineHeight: 20,
                          align: 'center',
                        },
                        hr: {
                          width: '100%',
                          height: 0,
                          alien: 'center',
                        },
                        per: {
                          color: '#000000',
                          align: 'center',
                          fontSize: 15,
                        },
                      },
                    },
                  },
                },
              ],
            });
            this.xData = [];
            this.yData = [];
            //自动适应大小
            window.addEventListener('resize', function () {
              myChart14.resize();
            });
          } else {
            this.$message({
              type: 'error',
              message: err.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.message,
          });
        });
    },
  },
  mounted() {
    this.Loading('woshi');
  },
};
</script>

<style>
.RPStatistics .box {
  background-color: rgb(240, 248, 255);
  padding-top: 30px;
}

.RPStatistics .box .bg-purple {
  height: 300px;
  border: 3px solid rgb(6, 139, 255);
  border-radius: 15px;
  width: calc(100%-100px);
  padding: 30px;
}

.RPStatistics .boxtitle {
  font-size: 26px;
  color: rgb(81, 183, 246);
  font-weight: 800;
}

.RPStatistics .boxtop {
  height: 50px;
  line-height: 50px;
  font-size: 26px;
  color: aliceblue;
  text-align: center;
  background: url('../../assets/staticTop.png') no-repeat top center;
}

.RPStatistics .report-head {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}
</style>
